import React, { useMemo } from 'react'
import ScrollObserver from '../Hooks/ScrollObserver'
import { MouseParallax, ScrollParallax } from 'react-just-parallax'
export default function AnimationProvider ({
  animation_options,
  strenth = 0.02,
  children
}) {
  const animationField = useMemo(() => {
    switch (animation_options) {
      case 'mouse-parallax':
        return (
          <MouseParallax strength={strenth} isAbsolutelyPositioned={true}>
            {children}
          </MouseParallax>
        )
      case 'scroll-parallax':
        return (
          <ScrollParallax strength={strenth} isAbsolutelyPositioned={true}>
            {children}
          </ScrollParallax>
        )
      case 'fade-mouse-p':
        return (
          <ScrollObserver>
            <MouseParallax strength={strenth} isAbsolutelyPositioned={true}>
              {children}
            </MouseParallax>
          </ScrollObserver>
        )
      case 'fade-scroll-p':
        return (
          <ScrollObserver>
            <ScrollParallax strength={strenth} isAbsolutelyPositioned={true}>
              {children}
            </ScrollParallax>
          </ScrollObserver>
        )
      case 'fade':
        return <ScrollObserver>{children}</ScrollObserver>
      default:
        return children
    }
  }, [animation_options , children, strenth])
  return (
    <div className='w-full h-full absolute z-0 overflow-hidden flex items-center justify-center top-0 left-0'>
      {animationField}
    </div>
  )
}
